import type { QuestionAnswer } from 'api/ai-builder/requests';

import { AssistantMessage } from './assistant-message';
import { ReasoningMessage } from './reasoning-message';
import { ToolMessage } from './tool-message';
import { UserMessage } from './user-message';

import type { ChatMessage } from '../../hooks';

type MessageItemProps = {
  message: ChatMessage;
  index: number;
  isPrevTool: boolean;
  isNextTool: boolean;
  isDescriptionOpen: boolean;
  onToggleDescription: () => void;
  onSubmitAnswers: (answers: QuestionAnswer[]) => Promise<void>;
  onAcceptPlan: () => Promise<void>;
  onRejectPlan: () => Promise<void>;
  isPlanLoading?: boolean;
};

export const MessageItem = ({
  message,
  index,
  isPrevTool,
  isNextTool,
  isDescriptionOpen,
  onToggleDescription,
  onSubmitAnswers,
  onAcceptPlan,
  onRejectPlan,
  isPlanLoading,
}: MessageItemProps) => {
  const { role, id, text } = message;

  return (
    <div key={`row-${id}`}>
      {role === 'assistant' && message.messageType === 'reasoning' && (
        <ReasoningMessage
          id={id}
          timeTakenSeconds={message.timeTakenSeconds}
          planSummary={message.planSummary}
          isExpanded={isDescriptionOpen}
          onToggle={onToggleDescription}
        />
      )}

      {role === 'assistant' && message.messageType !== 'reasoning' && (
        <AssistantMessage
          text={text}
          errorMessage={message.errorMessage}
          errorType={message.errorType}
        />
      )}

      {role === 'tool' && (
        <ToolMessage
          toolName={message.toolName}
          toolLabel={message.toolLabel}
          toolDescription={message.toolDescription}
          status={message.status}
          questions={message.questions}
          plan={message.plan}
          errorMessage={message.errorMessage}
          isNextTool={isNextTool}
          isDescriptionOpen={isDescriptionOpen}
          onToggleDescription={onToggleDescription}
          onSubmitAnswers={onSubmitAnswers}
          onAcceptPlan={onAcceptPlan}
          onRejectPlan={onRejectPlan}
          isPlanLoading={isPlanLoading}
        />
      )}

      {role === 'user' && <UserMessage id={id} text={text} files={message.files} />}
    </div>
  );
};
